import script from "./faqPage.vue?vue&type=script&setup=true&lang=js"
export * from "./faqPage.vue?vue&type=script&setup=true&lang=js"

import "./faqPage.vue?vue&type=style&index=0&id=0ef4756a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef4756a"]])

export default __exports__